import { render, staticRenderFns } from "./NonConformityDescriptionForm.vue?vue&type=template&id=0f0efc5e&scoped=true&"
import script from "./NonConformityDescriptionForm.vue?vue&type=script&lang=js&"
export * from "./NonConformityDescriptionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0efc5e",
  null
  
)

export default component.exports